import { Component, OnInit } from '@angular/core';
import { categoryDB } from 'src/app/shared/tables/category';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CategoryService } from 'src/app/shared/service/category.service';
import { subcategoryService } from 'src/app/shared/service/subcategory.service';
import { CategoryDTO, dropdown, SubCategoryDTO } from 'src/app/shared/models/model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styleUrls: ['./sub-category.component.scss']
})
export class SubCategoryComponent implements OnInit {
  public closeResult: string;
  public sub_categories: LocalDataSource;

  public categories: CategoryDTO[] = [];
  public subcategoryList: SubCategoryDTO[] = [];
  public SubCategory: SubCategoryDTO = new SubCategoryDTO();
  public countryForm: FormGroup;

  public categoryDropdownList:dropdown[]=[];
  public categoryDropdown:dropdown=new dropdown();
 

  // public subCategoryForm: FormGroup;
  constructor(private modalService: NgbModal, private backService: CategoryService, private subcategoryService: subcategoryService, private fb: FormBuilder) {
    this.sub_categories = new LocalDataSource();

    this.backService.getAllCategories().subscribe(data => {
      this.categories = data;
      // this.categories.forEach(element => {
      //   console.log(element);
      //   this.categoryDropdown.push(
  
      //     {
      //       value: element.idcategory,
      //       title: element.description
      //     }
  
      //   );
      // });
      this.fillCategoriesDowndown(this.categories);

    });

    this.subcategoryService.getSubcategories().subscribe(data => {
      this.subcategoryList = data;
      this.sub_categories = new LocalDataSource(this.subcategoryList);
    });





    console.log("categories");
    console.log(this.categories);
    this.countryForm = this.fb.group({
      countryControl: this.categories
    });
    
    console.log("subc");
    console.log(this.sub_categories);

  }

  fillCategoriesDowndown(categoriesList: any): any {
  

    categoriesList.forEach(element => {
      console.log(element);

      this.categoryDropdown=new dropdown();
      this.categoryDropdown.value=element.idcategory;
      this.categoryDropdown.title=element.description;
      console.log(this.categoryDropdown.value);
      console.log(this.categoryDropdown.title);
      this.categoryDropdownList.push(

        {

          title: this.categoryDropdown.title,
          value: this.categoryDropdown.value,
        }
      );

      this.settings.columns.categoryIdcategoryNavigation.editor.config.list.push({value: this.categoryDropdown.value,title:this.categoryDropdown.title});

      this.settings = Object.assign({}, this.settings);
    });
    this.sub_categories.load;

    console.log(this.settings.columns.categoryIdcategoryNavigation.editor.config.list);
   




      
  }



  open(content) {
    this.backService.getAllCategories().subscribe(data => {
      this.categories = data;
    });

    console.log("categories");
    console.log(this.categories);
    this.countryForm = this.fb.group({
      countryControl: this.categories
    });



    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  public settings = {
    "mode": "inline",
    delete: {
      "confirmDelete": "true"
    },
    edit: { "confirmSave": "true" },
    actions: {
      position: 'right'
    },
    columns: {
      img: {
        title: 'Image',
        type: 'html',
      },
      idsubcategory: {
        title: 'Id Subcategory',
        editable: false,
      },
      description: {
        title: 'Sub category',
        editable: true,
      },
      categoryIdcategoryNavigation: {
        title: '  category',
        valuePrepareFunction: (cell, row) => {
     
          return row.categoryIdcategoryNavigation.description;
        
        },
        editor: {
          type: 'list',
          config: {
            list:[],
          },
          editable: true,
        }
      },
    }
  };

  ngOnInit() {


  }

  getCategories() {
    alert("tet");
  }

  valuePrepareFunction(data) {
    return data.categoryIdcategoryNavigation.description;
  }

  deleteRecord(event) {
    this.subcategoryService.deleteSubCategory(event.data.idsubcategory);
    console.log(event.data);
    console.log(event.data.idsubcategory);
    window.location.reload();
  }


  onSubmit(subcategoryForm) {
    debugger
    
    this.SubCategory.description = subcategoryForm.value["Description"];
 
    console.log(this.countryForm.controls['countryControl'].value);

    this.SubCategory.CategoryIdcategory=this.countryForm.controls['countryControl'].value;


    console.log(this.SubCategory.description);
    // console.log(this.SubCategory.CategoryIdcategoryNavigation.idcategory);
    this.subcategoryService.addSubCategory(this.SubCategory);
    window.location.reload();

  }
  updateRecord(event) {
    debugger
    console.log("update record");
    console.log(event.newData);
    this.SubCategory.description = event.newData.description;
    this.SubCategory.CategoryIdcategoryNavigation=new CategoryDTO();
    this.SubCategory.CategoryIdcategoryNavigation.idcategory=event.newData.categoryIdcategoryNavigation;
    // this.SubCategory.CategoryIdcategoryNavigation.description=event.newData.categoryIdcategoryNavigation.description;
    this.SubCategory.idsubcategory = event.newData.idsubcategory;
    this.SubCategory.CategoryIdcategory=event.newData.categoryIdcategoryNavigation;
    this.subcategoryService.updateSubCategory(this.SubCategory);
    event.confirm.resolve();
    window.location.reload();
  }



  save() {
    alert('yes it works');
    console.log(this.countryForm.controls['countryControl'].value);
  }

}
